import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'

import DescriptionBox from './description-box'

export default function ContentMarketing ({ contents }) {
  return (
    <div className='content-blocks-wrapper'>
      {contents &&
        contents.map((content, index) =>
          content.contentType ? (
            <div
              className={`grid small-wide search-content-blocks ${content.contentType} ${
                content.isTitle ? 'removed-bottom' : ''
              } ${content.isPreviousTitle ? 'removed-top' : ''}`}
              key={index}
            >
              {content.contents.content1.description && !content.isTitle && content.contentType === 'three_columns' ? (
                <DescriptionBox
                  icon={content.contents.content1.icon}
                  description={content.contents.content1.description}
                />
              ) : (
                <div className={`content content-one ${content.isTitle && 'is-title'}`}>
                  {ReactHtmlParser(content.contents.content1.description)}
                </div>
              )}
              {content.contents.content2.description && !content.isTitle && content.contentType === 'three_columns' ? (
                <DescriptionBox
                  icon={content.contents.content2.icon}
                  description={content.contents.content2.description}
                />
              ) : (
                <div className={`content content-one ${content.isTitle && 'is-title'}`}>
                  {ReactHtmlParser(content.contents.content2.description)}
                </div>
              )}
              {content.contents.content3 ? (
                content.contents.content3.description && !content.isTitle && content.contentType === 'three_columns' ? (
                  <DescriptionBox
                    icon={content.contents.content3.icon}
                    description={content.contents.content3.description}
                  />
                ) : (
                  <div className={`content content-one ${content.isTitle && 'is-title'}`}>
                    {ReactHtmlParser(content.contents.content3.description)}
                  </div>
                )
              ) : null}
            </div>
          ) : null
        )}
    </div>
  )
}

ContentMarketing.propTypes = {
  contents: PropTypes.array
}
